/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';
import lodash from 'lodash';

// initial state
const state = {
  report: null,
  metricTemplate: {
    type: 'unit',
    aggregateType: 'sum',
    higherIsBetter: 1,
  },
  metrics: [
    {
      name: 'Allergy Tests - IGE',
      field: 'tests_ige',
    },
    {
      name: 'Allergy Tests - MQT',
      field: 'test_mqt',
    },
    {
      name: 'Allergy Tests - Pricks',
      field: 'tests_pricks',
    },
    {
      name: 'Allergy Tests - Sticks',
      field: 'tests_sticks',
    },
    {
      name: 'Subtotal Allergy Tests',
      field: 'tests_subtotal',
    },
    {
      name: '# SCIT Vials Mixed for New Patients',
      field: 'scit_vials_new_patients',
    },
    {
      name: '# SLIT Vials Mixed for New Patients',
      field: 'slit_vials_new_patients',
    },
    {
      name: 'Total New Patients with Vials Mixed',
      field: 'vials_total_new_patients',
    },
    {
      name: '# of Total SCIT Vials Mixed',
      field: 'scit_vials_total',
    },
    {
      name: '# of Total SLIT Vials Mixed',
      field: 'slit_vials_total',
    },
    {
      name: 'Total Vials Mixed',
      field: 'vials_total',
    },
    {
      name: 'Total Vials Mixed',
      field: 'vials_total',
    },
    {
      name: '# of Injections',
      field: 'num_injections',
    },
    {
      name: '# of New Patients on SCIT',
      field: 'num_new_patients_scit',
    },
    {
      name: '# of New Patients on SLIT',
      field: 'num_new_patients_slit',
    },
    {
      name: 'Total New Patients',
      field: 'new_patients_total',
    },
    {
      name: 'Total Active Patients on SCIT',
      field: 'total_active_patients_scit',
    },
    {
      name: 'Total Active Patients on SLIT',
      field: 'total_active_patients_slit',
    },
    {
      name: 'Total Active Patients on Unknown',
      field: 'total_active_patients_unknown',
    },
    {
      name: 'Total Active Allergy Patients',
      field: 'active_patients_subtotal',
    },
    {
      name: '# of Errors',
      field: 'num_errors',
      higherIsBetter: -1,
    },
    {
      name: '# of Mixing Locations',
      field: 'num_mixing_locations',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: '# of Physicians and Midlevel',
      field: 'num_physicians_and_midlevel',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: '# of Techs',
      field: 'num_techs',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: '# of Tests Per Physician',
      field: 'num_tests_per_physician',
      aggregateType: 'avg',
    },
    {
      name: '# of Tests Per Tech',
      field: 'num_tests_per_tech',
      aggregateType: 'avg',
    },
    {
      name: 'Testing to Treatment Conversion Rate',
      field: 'tested_to_treatment_conversion_rate',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: '% of New Patients on SCIT',
      field: 'percent_new_patients_on_scit',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: '% of New Patients on SLIT',
      field: 'percent_new_patients_on_slit',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: '# of Injections per Tech',
      field: 'num_injections_per_tech',
      aggregateType: 'avg',
    },
    {
      name: '# of Vials Mixed per Tech',
      field: 'num_vials_mixed_per_tech',
      aggregateType: 'avg',
    },
    {
      name: '# of Vials Mixed per Mixing Location',
      field: 'num_vials_mixed_per_mixing_location',
      aggregateType: 'avg',
    },
    {
      name: '# of Errors Per Tech',
      field: 'num_errors_per_tech',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
  ],
  prevYear: null,
  curYear: null,
  month: null,
  year: null,
  years: [],
  yearsList: [],
  comments: [],
  yearStart: null,
  activeSection: 'charts',
  compMode: 'number',
  prevYearNull: null,
  practiceSizes: null,
  practiceBenchmark: null,
  trackingSections: [
    { id: 'kpiTracking', name: 'KPI Tracking' },
    { id: 'locationsAndProviders', name: 'Practice Locations & Provider Information' },
    { id: 'testingStatistics', name: 'Testing Statistics' },
    { id: 'treatmentStatistics', name: 'Treatment Statistics' },
  ],
  metricsKpiTrackingFields: [
    'tests_ige',
    'tests_mqt',
    'tests_pricks',
    'tests_sticks',
    'tests_subtotal',
    'scit_vials_new_patients',
    'slit_vials_new_patients',
    'vials_total_new_patients',
    'scit_vials_total',
    'slit_vials_total',
    'vials_total',
    'num_injections',
    'num_new_patients_scit',
    'num_new_patients_slit',
    'new_patients_total',
    'total_active_patients_scit',
    'total_active_patients_slit',
    'total_active_patients_unknown',
    'active_patients_subtotal',
    'num_errors',
  ],
  metricsLocationsAndProvidersFields: [
    'num_mixing_locations',
    'num_techs',
    'num_physicians_and_midlevel',
  ],
  metricsTestingStatisticsFields: [
    'num_tests_per_physician',
    'num_tests_per_tech',
  ],
  metricsTreatmentStatisticsFields: [
    'tested_to_treatment_conversion_rate',
    'percent_new_patients_on_scit',
    'percent_new_patients_on_slit',
    'num_injections_per_tech',
    'num_vials_mixed_per_tech',
    'num_vials_mixed_per_mixing_location',
    'num_errors_per_tech',
  ],
  ytdCustomCalculationFields: [
    'tests_subtotal',
    'vials_total_new_patients',
    'new_patients_total',
    'vials_total',
    'active_patients_subtotal',
    'num_tests_per_physician',
    'num_tests_per_tech',
    'tested_to_treatment_conversion_rate',
    'percent_new_patients_on_scit',
    'percent_new_patients_on_slit',
    'num_injections_per_tech',
    'num_vials_mixed_per_tech',
    'num_vials_mixed_per_mixing_location',
    'num_errors_per_tech',
  ],
  monthAbbrevs: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  reportTotals: {
    curYear: {},
    prevYear: {},
    target: {},
  },
  loaders: {
    years: false,
    yearStart: false,
    kpiData: false,
    comments: false,
    practiceSizes: false,
  },
  initializers: {
    years: false,
  },
};

// getters
const getters = {
  cancelToken: (state, getters, rootState) => rootState.main.cancelToken,
  member_id: (state, getters, rootState) => rootState.main.member_id,
  compMode: (state) => state.compMode,
  initializers: (state) => state.initializers,
  loaders: (state) => state.loaders,
  metrics: (state) => lodash.map(state.metrics, (metric) => {
    return {
      ...state.metricTemplate,
      field: lodash.snakeCase(metric.name),
      ...metric,
    };
  }),
  month: (state) => state.month,
  year: (state) => state.year,
  years: (state) => state.years,
  yearsList: (state, getters) => lodash.map(state.years, (year) => ({
    value: year,
    label: !getters.yearStart || getters.yearStart === 1 ? year : `${state.year}/${parseInt(state.year.substring(2)) + 1}`,
  })),
  yearStart: (state) => state.yearStart,
  report: (state) => state.report,
  practiceSize: (state) => state.practiceSize,
  practiceBenchmark: (state, getters) => getters.curMonth.size,
  trackingSections: (state) => state.trackingSections,
  prevYear: (state) => state.report ? (state.prevYearNull ? state.report.curYear : state.report.prevYear) : null,
  curYear: (state) => state.report ? state.report.curYear : null,
  curMonth: (state, getters) => getters.curYear[(getters.month - 1)],
  prevYearMonth: (state, getters) => getters.prevYear[(getters.month - 1)],
  benchmarkMonth: (state, getters) => state.report.benchmark[(getters.month - 1)],
  benchmarkYear: (state) => state.report ? state.report.benchmark : [],
  comments: (state) => state.comments,
  fiscalYear: (state) => ([1, 12]).includes(state.yearStart),
  yearPrior: (state) => state.yearPrior,
  prevYearNull: (state) => state.report ? lodash.findIndex(state.years, (year) => parseInt(year) === parseInt(state.year)) === state.years.length - 1 : true,
  yearCurrent: (state) => state.yearCurrent,
  latestMonth: (state) => (state.curYear ? state.curYear[state.curYear.length - 1].month : null),
  activeSection: (state) => state.activeSection,
  monthNames: (state) => lodash.map(state.monthNames, (monthName, index, collection) => (index === 0 || state.yearStart === 1) ? monthName : collection[((index + (state.yearStart - 2)) % 12) + 1]),
  monthAbbrevs: (state) => lodash.map(state.monthAbbrevs, (monthAbbrev, index, collection) => (index === 0 || state.yearStart === 1) ? monthAbbrev : collection[((index + (state.yearStart - 2)) % 12) + 1]),
  ytdCustomCalculationFields: (state) => state.ytdCustomCalculationFields,
  globalLoading: (state, getters, rootState) => rootState.main.globalLoading,
  hasData: (state) => !!state.year,
  metricsKpiTracking: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsKpiTrackingFields.includes(metric.field)),
  metricsLocationsAndProviders: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsLocationsAndProvidersFields.includes(metric.field)),
  metricsTestingStatistics: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsTestingStatisticsFields.includes(metric.field)),
  metricsTreatmentStatistics: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsTreatmentStatisticsFields.includes(metric.field)),
  monthsInReport: (state, getters) => {
    return lodash.reduce(getters.curYear, (monthsWithKPIData, month) => {
      const index = ((parseInt(month.month, 10) - 1) - (state.yearStart - 1)) % 12;
      monthsWithKPIData.push({
        value: index + 1,
        label: state.monthNames[index],
      });
      return monthsWithKPIData;
    }, []);
  },
};

// actions
const actions = {
  getAllergyKpisYears({ commit }) {
    axios.get('/api/allergy/kpis/getAllergyKpiYears')
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'years', value: data });
        commit('SET_PROPERTY', { key: 'year', value: data[0] });
        commit('TOGGLE_INITIALIZED', { key: 'years', value: true });
      });
  },
  getAllergyKpisYearStart({ commit }) {
    axios.get('/api/allergy/kpis/getAllergyKpiYearStart')
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'yearStart', value: parseInt(data) });
      });
  },
  getReport({ commit, dispatch, getters }) {
    commit('TOGGLE_LOADING', { key: 'kpiData', value: true });
    dispatch('main/setProperty', { key: 'globalLoading', value: true }, { root: true });
    return axios.get(`/api/allergy/kpis/report/?filters[year]=${getters.year}`)
      .then((response) => {
        commit('SET_PROPERTY', { key: 'report', value: response.data });
        commit('SET_PROPERTY', { key: 'month', value: response.data.curYear ? response.data.curYear.length : 12 });
        commit('TOGGLE_LOADING', { key: 'kpiData', value: false });
        dispatch('main/setProperty', { key: 'globalLoading', value: false }, { root: true });
      });
  },

  getPracticeSizes({ commit }) {
    commit('TOGGLE_LOADING', { key: 'practiceSizes', value: true });
    return axios.get('/api/allergy/kpis/practiceSizes/')
      .then((response) => {
        commit('SET_PROPERTY', { key: 'practiceSizes', value: response.data });
        commit('TOGGLE_LOADING', { key: 'practiceSizes', value: false });
      });
  },

  getComments({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'comments', value: true });
    return axios.get(`/api/allergy/kpis/comments/?filters[year]=${getters.year}&filters[month]=${getters.month}`)
      .then((response) => {
        commit('SET_PROPERTY', { key: 'comments', value: response.data });
        commit('TOGGLE_LOADING', { key: 'comments', value: true });
      });
  },

  async cancelAjax({ dispatch }) {
    await dispatch('main/cancelAjax', { root: true });
    return;
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
